import * as fetchViolation from "./fetchViolation";
import * as violation from "./violation";
import { initialState as violationInitialState, ViolationRequestInfoState } from "./violation";
import { initialState as fetchViolationInitialState, FetchViolationInfoState } from "./fetchViolation";
import reduceReducers from "reduce-reducers";


export const Types: { [key: string]: any } = {
    ...fetchViolation.Types,
    ...violation.Types
};

export const Actions: { violation: typeof violation.Actions, fetchViolation: typeof fetchViolation.Actions } = {
    violation: violation.Actions,
    fetchViolation: fetchViolation.Actions
};

export const violationRequestReducer = reduceReducers<ViolationRequestInfoState>(
    violationInitialState,
    violation.default as any
);

export const fetchViolationRequestReducer = reduceReducers<FetchViolationInfoState>(
    fetchViolationInitialState,
    fetchViolation.default as any
);

export default {
    violation: violationRequestReducer,
    fetchViolation: fetchViolationRequestReducer
};